import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { api } from "@/api";
import { formatError, useAuth } from "@/auth";
import { LOGO_URL } from "@/pages/LoginPage";
import { homeFor } from "@/permissions";

export default function InvitationPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [invite, setInvite] = useState(null);
  const [form, setForm] = useState({ name: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/public/invitations/${token}`).then(({ data }) => { setInvite(data); setForm((f) => ({ ...f, name: data.name })); }).catch((e) => setError(formatError(e.response?.data?.detail))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Les deux mots de passe ne correspondent pas.");
    try {
      const { data } = await api.post(`/public/invitations/${token}`, { name: form.name, password: form.password });
      const me = await api.get("/auth/me"); setUser(me.data);
      navigate(data.project_id ? `/projets/${data.project_id}` : homeFor(me.data), { replace: true });
    } catch (err) { setError(formatError(err.response?.data?.detail)); }
  };
  return (
    <main className="login-page" data-testid="invitation-page">
      <form className="login-card" onSubmit={submit}>
        <img src={LOGO_URL} alt="Airthermo" className="login-logo" />
        {invite ? invite.kind === "reset" ? <><h1>Nouveau mot de passe</h1><p>Choisissez un nouveau mot de passe pour <strong>{invite.email}</strong>.</p></> : <><h1>{invite.project_name ? `Rejoindre « ${invite.project_name} »` : "Bienvenue sur le CRM Airthermo"}</h1><p>Créez votre mot de passe pour vous connecter avec <strong>{invite.email}</strong>.</p></> : !error && <p>Chargement de l'invitation…</p>}
        {invite && <>
          {invite.kind !== "reset" && <input placeholder="Votre nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="invite-name" />}
          <input type="password" placeholder="Mot de passe (8 caractères min.)" minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="invite-password" />
          <input type="password" placeholder="Confirmez le mot de passe" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required data-testid="invite-confirm" />
        </>}
        {error && <p className="login-error" data-testid="invite-error">{error}</p>}
        {invite && <button type="submit" className="primary-button" data-testid="invite-submit">{invite.kind === "reset" ? "Enregistrer et me connecter" : invite.project_name ? "Accéder au projet" : "Accéder au CRM"}</button>}
      </form>
    </main>
  );
}
